'use client';

import { useLogic } from './logic';
import { Box, Typography } from '@mui/material';
import { MuiIconButton } from '@/components/button/MuiIconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ibow2_proto_PortalOfficeHospitalListingImage } from '@/init/swagger';

type Props = {
  images?: ibow2_proto_PortalOfficeHospitalListingImage;
};

const navButtonCommonStyle = {
  position: 'absolute',
  top: '50%',
  transform: `translateY(-50%)`,
  display: 'none',
};

export function HospitalCarouselImages({ images }: Props) {
  const {
    emblaRef,
    scrollPrev,
    scrollNext,
    canScrollPrev,
    canScrollNext,
    currentSlide,
    buttonSize,
    captionTextVariant,
    imageUrlList,
  } = useLogic({
    images,
  });

  if (!images?.image1_url) {
    if (images) {
      // images.image1_url = NoImagePNG.src;
    }
  }

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        ':hover': {
          '.slide-container': {
            filter: `brightness(70%)`,
          },
          '.slide-count': {
            display: 'block',
          },
          '.nav-button': {
            display: 'inline-flex',
            bgcolor: 'white',
            ':disabled': {
              bgcolor: 'transparent',
            },
            ':hover': {
              bgcolor: '#f5f5f5',
            },
          },
        },
      }}
    >
      <Box
        className="slide-container"
        ref={emblaRef}
        sx={{ overflow: 'hidden', width: '100%', borderRadius: 1 }}
      >
        <Box sx={{ display: 'flex' }}>
          {imageUrlList.map((url, index) => (
            <Box
              key={`image-${index}`}
              sx={{
                flex: '0 0 100%',
                minWidth: 0,
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                height: '400px',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: 'auto',
                  position: 'relative',
                }}
              >
                <img
                  src={url}
                  alt={`image-${index}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <MuiIconButton
        className="nav-button"
        size={buttonSize}
        sx={{
          left: '16px',
          ...navButtonCommonStyle,
        }}
        disabled={!canScrollPrev}
        onClick={scrollPrev}
      >
        <ChevronLeftIcon fontSize={buttonSize} />
      </MuiIconButton>
      <MuiIconButton
        className="nav-button"
        size={buttonSize}
        sx={{
          right: '16px',
          ...navButtonCommonStyle,
        }}
        disabled={!canScrollNext}
        onClick={scrollNext}
      >
        <ChevronRightIcon />
      </MuiIconButton>
      <Box
        className="slide-count"
        sx={{
          background: '#00000066',
          width: 'max-content',
          px: 1,
          borderRadius: 1,
          position: 'absolute',
          bottom: '16px',
          right: '16px',
          display: 'none',
          lineHeight: 1,
        }}
      >
        <Typography color="white" variant={captionTextVariant}>
          {currentSlide}/{imageUrlList.length}枚
        </Typography>
      </Box>
    </Box>
  );
}
